import { COMMON_CONSTANTS } from '@nile/components';

const NEWREPORTID = 'B604yRELWW';
const SCHEDULE_TITLE = {
  METRIC: 'reports.dashboard.modal.schedule.title',
  RETAINER: 'reports.dashboard.modal.schedule.title',
  PDF: 'reports.report.modal.schedule.title',
  DATA: 'reports.report.modal.schedule.title'
};

const SHARE_TITLE = {
  METRIC: 'reports.dashboard.share.title',
  RETAINER: 'reports.dashboard.share.title',
  PDF: 'reports.other.report.share.title',
  DATA: 'reports.other.report.share.title',
  INVOICE_STATEMENTS: 'reports.dashboard.share.title'
};

const DEFAULT_REPORT_CONDITION = 'placeholder.last.30.days';
const EDIT_MODE = 'EDIT';
const VIEW_MODE = 'VIEW';
const CREATE_MODE = 'CREATE';
const DEFAULT_VIEW = 'default';
const CUSTOM_VIEW = 'custom';
const RETAINER_REPORT = 'RETAINER_REPORT';

const CHARTS = 'charts';
const REPORTS = 'report';

const DEFAULT_CONDITION_ENUM = {
  DISABLE: null,
  LAST_30_DAYS: 'placeholder.last.30.days',
  LAST_SIX_MONTH: 'placeholder.last.six.months',
  LAST_QUARTER: 'placeholder.last.quarter',
  THIS_QUARTER: 'placeholder.this.quarter',
  THIS_WEEK: 'placeholder.this.week',
  LAST_WEEK: 'placeholder.last.week',
  LAST_MONTH: 'placeholder.last.month',
  THIS_MONTH: 'placeholder.this.month',
  LAST_YEAR: 'lastYear',
  THIS_YEAR: 'thisYear',
  NULL: null
};

const REPORT_PATHNAME = {
  DATA: 'datareport',
  METRIC: 'report',
  RETAINER: 'report',
  PDF: 'pdfreport',
  EFFICIENCY_REPORT: 'efficiency',
  EFFICIENCY: 'efficiency',
  PROFITABILITY: 'profitablity',
  INVOICE_STATEMENTS: 'report'
};

const EFFICIENCY_REPORTS = ['CLIENT_RESOURCE_EFFICIENCY'];

const CONFIGURATION_ICON_MAP = {
  diskSpace: 'AssetDiskUsage',
  ramSpace: 'AssetMemoryUsage'
};

const DATA_REPORT = 'datareport';
const DATA_REPORT_TYPE = 'DATA';

const METRIC_REPORT = 'METRIC';

const PDF_REPORT = 'PDF';
const RETAINER = 'RETAINER';
const INVOICE_STATEMENTS = 'INVOICE_STATEMENTS';

const EFFICIENCY_REPORT = 'EFFICIENCY';
const PROFITABLITY_REPORT = 'PROFITABILITY';
const EFFICIENCY_REPORT_URL = 'efficiency';

const PDF_REPORT_MAP = [
  {
    id: '10001',
    sampleReportImgUrl: 'patch-summary-report-pdf-report'
  },
  {
    id: '10002',
    sampleReportImgUrl: 'patch-details-pdf-report'
  },
  {
    id: '10003',
    sampleReportImgUrl: 'software-pdf-report'
  },
  {
    id: '10004',
    sampleReportImgUrl: 'asset-activity-pdf-report'
  },
  {
    id: '10005',
    sampleReportImgUrl: 'asset-health-report'
  },
  {
    id: '10006',
    sampleReportImgUrl: 'executive-summary-report'
  },
  {
    id: '10007',
    sampleReportImgUrl: 'remote-report'
  },
  {
    id: '10008',
    sampleReportImgUrl: 'software-activity-report'
  }
];

const USER_KEY_MAP = (currentProduct: string) => {
  return {
    TECHNICIAN:
      currentProduct == COMMON_CONSTANTS.MSP
        ? 'entity.technician'
        : 'common.user',
    REQUESTER: 'common.client'
  };
};

const CONSTANT_MAPPING = {
  METRIC: 'SHARE_METRIC_REPORT',
  PDF: 'SHARE_PDF_REPORT',
  DATA: 'SHARE_DATA_REPORT',
  INVOICE_STATEMENTS: 'SHARE_INVOICE_STATEMENTS'
};

export {
  NEWREPORTID,
  EDIT_MODE,
  VIEW_MODE,
  CREATE_MODE,
  DEFAULT_VIEW,
  CUSTOM_VIEW,
  DEFAULT_REPORT_CONDITION,
  DEFAULT_CONDITION_ENUM,
  DATA_REPORT,
  PDF_REPORT,
  PDF_REPORT_MAP,
  DATA_REPORT_TYPE,
  CHARTS,
  REPORT_PATHNAME,
  REPORTS,
  METRIC_REPORT,
  SCHEDULE_TITLE,
  SHARE_TITLE,
  EFFICIENCY_REPORT_URL,
  EFFICIENCY_REPORT,
  CONFIGURATION_ICON_MAP,
  USER_KEY_MAP,
  CONSTANT_MAPPING,
  PROFITABLITY_REPORT,
  EFFICIENCY_REPORTS,
  RETAINER_REPORT,
  RETAINER,
  INVOICE_STATEMENTS
};
